'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionStatus", "children"];
import PropTypes from 'prop-types';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ActionStatusesPropType, ACTION_STATUSES } from './actionStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSubmitButton = _ref => {
  let {
      actionStatus = ACTION_STATUSES.NOT_STARTED,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    use,
    ['data-test-id']: dataTestId,
    disabled,
    onClick
  } = rest;
  return /*#__PURE__*/_jsx(LoadingButton, {
    loading: actionStatus === ACTION_STATUSES.PENDING,
    failed: actionStatus === ACTION_STATUSES.FAILED,
    keepResultAfterFinish: true,
    use: use,
    "data-test-id": dataTestId,
    disabled: disabled,
    onClick: onClick,
    children: children
  });
};
ActionSubmitButton.propTypes = {
  actionStatus: ActionStatusesPropType,
  children: PropTypes.node
};
export default ActionSubmitButton;